const apiBaseUrl = (process.env.VUE_APP_PUBLIC_API_BASE_URL || 'http://localhost:5235').replace(/\/$/, '')

const jsonHeaders = {
  'Content-Type': 'application/json'
}

function withBaseUrl(path) {
  if (!apiBaseUrl) return path
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return `${apiBaseUrl}${path.startsWith('/') ? '' : '/'}${path}`
}

async function requestJson(url, options = { "credentials": "include" }) {
  const response = await fetch(withBaseUrl(url), options)
  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`)
    error.status = response.status
    throw error
  }
  const text = await response.text()
  if (!text) return null
  return JSON.parse(text)
}

export async function getEventBySlug(eventSlug) {
  return requestJson(`/api/public/events/${encodeURIComponent(eventSlug)}`)
}

export async function getEventBusiness(eventSlug) {
  return requestJson(`/api/public/events/${encodeURIComponent(eventSlug)}/business`)
}

export async function getEventLeaderboard(eventSlug) {
  return requestJson(`/api/public/events/${encodeURIComponent(eventSlug)}/leaderboard`)
}

export async function getItemByShortCode(eventSlug, itemShortCode) {
  return requestJson(
    `/api/public/events/${encodeURIComponent(eventSlug)}/items/${encodeURIComponent(itemShortCode)}`
  )
}

export async function getItemQuestions(eventSlug, itemShortCode) {
  return requestJson(
    `/api/public/events/${encodeURIComponent(eventSlug)}/items/${encodeURIComponent(itemShortCode)}/questions`
  )
}

export async function getAnswerStatus(eventSlug, itemShortCode) {
  return requestJson(
    `/api/public/events/${encodeURIComponent(eventSlug)}/items/${encodeURIComponent(itemShortCode)}/answers/status`
  )
}

export async function submitAnswers(eventSlug, itemShortCode, payload) {
  return requestJson(
    `/api/public/events/${encodeURIComponent(eventSlug)}/items/${encodeURIComponent(itemShortCode)}/answers`,
    {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload)
    }
  )
}
